import React from 'react'
import { StoreDetailsInfoCard } from '../StoreDetailsInfoCard'
import useBreakpoint from '../../../../../lib/useBreakpoint'
import { StoreProfileFPTI } from '../../../../store-profile/StoreProfilePage'
export interface StoreDetail {
  title: string
  icon?: { url: string }
  content?: string
}

export const StoreDetailsInfoSection = ({
  fptiData,
  storeDetails
}: {
  fptiData: StoreProfileFPTI | null
  storeDetails: StoreDetail[]
}) => {
  const { isMobile, isTablet } = useBreakpoint()
  const generateColumns = () => {
    let cardColumn: JSX.Element[] = []
    storeDetails.forEach((storeDetail, idx) => {
      const infoCard = (
        <StoreDetailsInfoCard
          key={`${idx}: ${storeDetail.title}`}
          {...storeDetail}
          fptiData={fptiData}
          isMobile={isMobile}
        />
      )
      cardColumn.push(infoCard)
    })
    return {
      cardColumn
    }
  }

  let generatedColumns = generateColumns()
  if (isMobile || isTablet) {
    return (
      <div className="store-details-info-section">
        {generatedColumns.cardColumn}
      </div>
    )
  }

  return (
    <div className="store-details-info-section">
      <div
        className="store-details-info-section__column"
        data-cy="store-details-info-section__column"
      >
        {generatedColumns.cardColumn}
      </div>
    </div>
  )
}
